<template>
  <div>
    <HeaderComponent></HeaderComponent>
    <!-- Content -->
    <content>
      <div class="container py-5">
        <div class="row mb-3 align-items-center" v-if="navigation.sides.Building.show == false">
          <div class="col-12 col-md-9">
            <h5>{{ configuration.description }}</h5>
          </div>
        </div>
        <div v-if="navigation.sides.Building.show == true && $root.ready">
          <BasicData></BasicData>
        </div>
        <div v-if="navigation.sides.Rooms.show == true && $root.ready">
          <RoomRecording></RoomRecording>
        </div>
        <div v-if="navigation.sides.AirVolumes.show == true && $root.ready">
          <AirvolumeAndDetails></AirvolumeAndDetails>
        </div>
        <div v-if="navigation.sides.Devices.show == true && $root.ready">
          <DeviceSelection></DeviceSelection>
        </div>
        <div v-if="navigation.sides.Equipments.show == true && $root.ready">
          <EquipmentSelection></EquipmentSelection>
        </div>
        <div v-if="navigation.sides.Overview.show == true && $root.ready">
          <Overview></Overview>
        </div>

        <div class="row mt-4" style="gap: 15px">
          <div style="gap: 10px" class="col-sm-12 d-flex justify-content-center justify-content-md-start flex-wrap">
            <div class="d">
              <a class="btn btn-primary"
                 :class="user.auth && configuration.project && !configuration.project.useraccess ? '' : 'disabled'"
                 @click="setProjectData()">
                <svg class="icon icon-xs mr-2">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.save"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                <span>{{ __('lang.kwl.basic.save') }}</span>
              </a>
            </div>

            <!--                         <div class="" v-if="navigation.sides.AirVolumes.show == true">
                <a class="btn btn-primary" @click="navigationController('Overview')">
                    <span>{{ __("lang.kwl.nav.result") }}</span>
                </a>
            </div> -->
          </div>

          <!--<hr class="border my-3 w-100">-->

          <div style="gap: 10px" class="col-sm-12 d-flex justify-content-center justify-content-md-between">
            <div class="">
              <a class="btn btn-primary" @click="clearSession" v-if="navigation.sides.Building.show == true">
                <span>{{ __('lang.kwl.basic.reset') }}</span>
              </a>

              <a class="btn btn-primary" :class="navigation.previousClasses" @click="navigationController('previous')"
                 v-else>
                <svg class="icon icon-xs pr-1 m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.previous"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                <span class="small">{{ __('lang.kwl.nav.previous_step') }}</span>
              </a>
            </div>

            <div class="">
              <a class="btn btn-primary next-step" @click="navigationController('next')" :class="navigation.nextClasses"
                 v-if="navigation.sides.Overview.show == false">
                <span class="small">{{ __('lang.kwl.nav.next_step') }}</span>
                <svg class="icon icon-xs pl-1 m-0">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.next"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>

              <a class="btn btn-primary next-step" data-toggle="modal" @click="openDownloadModal()" v-else> Ausgabe </a>
            </div>
          </div>
        </div>
      </div>
    </content>
    <!-- /Content -->
    <ModalComponent></ModalComponent>
    <b-modal id="bv-modal-device-warning" ref="bv-modal-device-warning" hide-footer hide-header centered no-close-on-esc
             no-close-on-backdrop>
      <div class="d-block">
        <h4 class="font-weight-bold mb-4">{{ __('lang.kwl.device_warning.headline') }}</h4>
        <p class="small">{{ __('lang.kwl.device_warning.text_1') }} <span
          class="font-weight-bold">{{ __('lang.kwl.device_warning.text_2') }}</span>
          {{ __('lang.kwl.device_warning.text_3') }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {getInitializationData} from '@services/helpers/initializationHandler'
import {clearSession, getUserData} from '@services/helpers/sessionHandler'
import {saveConfiguration, setConfiguration, storeUserConfiguration} from '@services/helpers/configurationHandler'

import HeaderComponent from './Header/MainComponent'

import BasicData from './BuildingData/MainComponent'
import RoomRecording from './RoomRecording/MainComponent'
import AirvolumeAndDetails from './AirvolumeAndDetails/MainComponent'
import DeviceSelection from './DeviceSelection/MainComponent'
import EquipmentSelection from './EquipmentSelection/MainComponent'
import Overview from './Overview/MainComponent'

import ModalComponent from './ModalComponent'

import Configuration from '@models/project/Configuration'
import Building from '@models/building/Building'
import Unit from '@models/building/Unit'

export default {
  components: {
    ModalComponent,
    BasicData,
    RoomRecording,
    AirvolumeAndDetails,
    DeviceSelection,
    EquipmentSelection,
    Overview,
    HeaderComponent,
  },
  data() {
    return {}
  },
  methods: {
    getInitializationData: getInitializationData,
    clearSession: clearSession,
    storeUserConfiguration: storeUserConfiguration,
    setProjectData() {
      if (this.configuration.service_id != null) {
        saveConfiguration(this.configuration)
      } else {
        this.$store.dispatch('modalSettings/setComponent', 'SaveConfiguration')
        this.$store.dispatch('modalSettings/isLarge', false)
        this.$store.dispatch('modalSettings/callRef', {type: 2})
        this.$store.dispatch('modalSettings/open')
      }
    },
    openDownloadModal() {
      this.$store.dispatch('modalSettings/setComponent', 'DownloadModal')
      this.$store.dispatch('modalSettings/isLarge', false)
      this.$store.dispatch('modalSettings/open')
    },
    navigationController(key) {
      switch (key) {
        case 'next':
          this.$store.dispatch('navigation/next')
          break
        case 'previous':
          this.$store.dispatch('navigation/previous')
          break
        default:
          this.$store.dispatch('navigation/setSide', key)
          break
      }
    },
  },

  beforeCreate() {
    this.$enableLoadingAnimation()
    if (Building.all().length <= 0) {
      Building.create({
        data: {
          units: [{}],
        },
      })
      var unit = Unit.query().first()
      unit.setDefaultsByType()
    }
  },
  async created() {
    if ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      ||
      (navigator.userAgent.includes('Mac') && ('ontouchend' in document || navigator.maxTouchPoints > 0))
    ) {
      return
    }
    await this.getInitializationData()

    window.Lang = this.__
    if (window.session_has_user) {
      this.$store.dispatch('session/setTimer')
      await getUserData()

      if (window.configuration != null && window.building != null) {
        await setConfiguration()
      }
    } else {
      this.$store.dispatch('session/clearTimer')
      this.$store.dispatch('session/resetState')
    }

    if (window.alert_message != '' && window.alert_type != '') {
      this.$store.dispatch('alert/setAlert', {
        type: window.alert_type,
        message: this.__(window.alert_message),
      })
    } else if (window.session_has_user && window.user_needs_registration) {
      this.$store.dispatch('alert/setAlert', {
        type: 'info',
        message: this.__('lang.kwl.alert.registration_not_complete'),
        time: 9999999
      })
    }

    this.$root.ready = true
  },
  mounted() {

    if ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      ||
      (navigator.userAgent.includes('Mac') && ('ontouchend' in document || navigator.maxTouchPoints > 0))
    ) {
      this.$disableLoadingAnimation()
      this.$refs['bv-modal-device-warning'].show()
    }
  },
  computed: {
    navigation: {
      get() {
        return this.$store.state.navigation.value
      },
    },
    user: {
      get() {
        if (this.$root.ready) {
          return this.$store.state.session.user
        } else {
          return {}
        }
      },
    },
    configuration() {
      return Configuration.query().with(['project']).first()
    },
  },
}
</script>
